/**
 * Unified dayjs instance, pre-configured with all plugins used across the
 * monorepo. Import this instead of configuring dayjs in every file.
 *
 * @example
 * ```ts
 * import { dayjs } from "@thalamos/common";
 *
 * const now = dayjs();
 * const london = now.tz("Europe/London");
 * ```
 */
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
import duration from "dayjs/plugin/duration.js";
import isoWeek from "dayjs/plugin/isoWeek.js";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter.js";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore.js";
import minMax from "dayjs/plugin/minMax.js";
import relativeTime from "dayjs/plugin/relativeTime.js";
import timezone from "dayjs/plugin/timezone.js";
import utc from "dayjs/plugin/utc.js";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isoWeek);
dayjs.extend(relativeTime);
dayjs.extend(minMax);
dayjs.extend(customParseFormat);
export { dayjs };
//# sourceMappingURL=dayjs.js.map